import type { ComponentProps } from 'react';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = ComponentProps<typeof Sonner>;

/** Toasts no estilo do protótipo (fundo verde-escuro, canto inferior direito). */
const Toaster = (props: ToasterProps) => (
  <Sonner
    position="bottom-right"
    richColors
    closeButton
    toastOptions={{
      classNames: {
        toast: 'font-sans text-sm rounded-[9px] shadow-[0_10px_25px_#10251c30]',
      },
    }}
    {...props}
  />
);

export { Toaster };
